<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'My personal development'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingsMine"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="screen.gsList"
										><ng-container *ngIf="screen.gsList.length; else else57"
											><div
												class="layout-block vertical"
												[style.align-items]="'inherit'"
												[style.gap]="'1em'"
											>
												<div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.grid-horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.--layout-column-count]="3"
													[style.gap]="'1em'"
												>
													<mat-form-field
														class="has-selectionChange-handler"
														appearance="fill"
														[style.grid-column]="'span ' + (1)"
														(selectionChange)="handler_DropdownBlock_61_selectionChange_$adhoc_0($event, { $disabled: $disabled })"
													>
														@let $fc_61_1 = getFormControl(screen,
														'selectedGs', 61, $scope, $formDirective,
														$disabled, $ignoreValidations);

														<mat-label
															[innerHtml]="'Development period' | escapeHtml"
														></mat-label>
														<mat-select
															class="has-selectionChange-handler"
															(selectionChange)="handler_DropdownBlock_61_selectionChange_$adhoc_0($event, { $disabled: $disabled })"
															[formControl]="$fc_61_1"
															[compareWith]="$compare"
															#select_61="matSelect"
															[lgFormComponent]="select_61"
															[lgFormValue]="screen.selectedGs"
															canSelectNullableOptions
															[multiple]="false"
														>
															@let emptyOption_61 = null; @if
															(emptyOption_61) {
															<mat-option [value]="emptyOption_61[0]"
																>{{ emptyOption_61[1] }}</mat-option
															>
															}

															<mat-option
																*ngFor="let $option of (screen.gsList); let $index = index"
																[value]="$option"
															>
																<span
																	[innerHtml]="$option.cycle.getDateRange() | escapeHtml"
																	style="margin: auto 0"
																></span>
															</mat-option>
														</mat-select>
													</mat-form-field>
													<mat-form-field
														*ngIf="$any(screen.selectedGs)?.$isOther"
													>
														@let $fc_61_3 =
														getFormControl(screen.selectedGs,
														'$otherValue', 61, $scope, $formDirective,
														$disabled, $ignoreValidations);
														<mat-label
															[innerHtml]="'Development period' + ' (Other)' | escapeHtml"
														></mat-label>
														<input
															type="text"
															matInput
															[formControl]="$fc_61_3"
														/>
													</mat-form-field>
												</div></div
										></ng-container>
										<ng-template #else57>
											<span
												style="font-style: italic"
												[innerHtml]="'There is currently no personal development process for you' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span> </ng-template
									></ng-container>

									<ng-container *ngIf="screen.gs"
										><mat-card>
											<mat-card-header>
												<mat-card-title
													><span
														[innerHtml]="`Personal development ${screen.gs.cycle.getDateRange()}` | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span
												></mat-card-title>
											</mat-card-header>

											<mat-card-content>
												<Toolbox-GoalSettingViewInclude
													[$formDirective]="$formDirective"
													[$disabled]="$disabled"
													[$ignoreValidations]="$ignoreValidations"
													[gs]="screen.gs"
													[viewMode]="screen.viewMode"
												>
												</Toolbox-GoalSettingViewInclude>
											</mat-card-content> </mat-card
									></ng-container>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
